import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import moment from "moment";
import TextContainer from "../../../components/Texts/TextContainer";
import { Message } from "../../../types/message";
import { Row } from "../../../global/styledComponents";
import DeleteIcon from '@mui/icons-material/Delete';

type ChatMessageProps = Message & {
  isMyMessage: boolean;
};

const ChatMessage = ({
  message,
  isMyMessage,
  createdAt,
  sender,
}: ChatMessageProps) => {
  return (
    <Box
      display="flex"
      justifyContent={"flex-start"}
      flexDirection={!isMyMessage ? "row-reverse" : "row"}
      mb={1}
    >
      {!isMyMessage && (
        <TextContainer>{sender.userName}</TextContainer>
      )}
      <Tooltip
        placement={isMyMessage ? "left" : "right"}
        title={
          <Row>
            <IconButton size="small" >
              <DeleteIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Row>
        }>

        <Box
          bgcolor={!isMyMessage ? "secondary.main" : "customColors.purple"}
          color={!isMyMessage ? "secondary.main" : "primary.main"}
          p={".3rem 1rem"}
          boxShadow={1}
          borderRadius="12px"
          display="flex"
          justifyContent="space-between"
          flexDirection="column"
          position="relative"
          sx={{
            borderBottomRightRadius: !isMyMessage ? "10px" : 0,
            borderBottomLeftRadius: !isMyMessage ? 0 : "10px",
          }}
          maxWidth="80%"
        >
          <TextContainer fontSize=".75rem">{message}</TextContainer>
          <TextContainer
            fontSize=".6rem"
            width="100%"
            justifyContent={!isMyMessage ? "left !important" : "right !important"}
          >
            {moment(createdAt).format("YY/MM/DD _ hh:mm")}
          </TextContainer>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default ChatMessage;
